<template>
    <div>
      <PageHeader :page_title="page_title"/>
      <pSpinner v-if="loading"></pSpinner>
      <template v-if="!loading">
        
        <v-form>
          <v-container justify-center fluid>
            <v-layout row wrap justify-center >
              
              <v-flex xs12 md12 lg12 xl12>
                <v-container grid-list-md fluid text-xs-center class="ma-0 pa-0">
                  <v-layout row wrap>
                    
                    <v-flex xs12 sm12 md4>
                      <v-card class="mx-auto" height="100%">
                        <v-container  fluid>
                          <v-layout  class="text-xs-center text-md-center">
                            <v-flex xs12 align-end flexbox>
                              <v-avatar :size="120" color="grey lighten-4">
                                <!--<img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSLv2g2aYvbC0tYZP5qbqj8arLF5Y7Sie5AXgT0UzIJIKmVg2sOkA" alt="avatar">-->
                                <!--<img v-if="rb_base_url==''"src="https://cdn4.vectorstock.com/i/1000x1000/35/53/person-icon-female-user-profile-avatar-vector-18833553.jpg" alt="avatar" >-->
                                <img :src="image_url" alt="avatar" >
                                
                              </v-avatar>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      <v-container class="text-xs-center text-md-center text-sm-center">
                        <v-flex class="text-xs-center text-md-center text-sm-center"  xs12 sm12 md12>
                           <table class="mytable mytable-head" cellpadding="10">
                            <tr>
                              <td  class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="35%">Customer ID</td>
                              <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="5%">:</td>
                              <td class="text-xs-left text-md-left text-sm-left" width="60%" style="font-size:13px;">{{ customer.id }}</td>
                            </tr>
                             <tr>
                              <td  class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="30%">Name</td>
                              <td class="text-xs-left text-md-left text-sm-left  grey--text "  width="5%">:</td>
                              <td class="text-xs-left text-md-left text-sm-left" width="60%" style="font-size:13px;">{{ customer.first_name }} {{customer.middle_name}} {{customer.last_name}}</td>
                            </tr>
                            <tr>
                              <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="30%">Email ID</td>
                              <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="5%">:</td>
                              <td class="text-xs-left text-md-left text-sm-left" width="60%" style="font-size:13px;">{{ customer.email }}</td>
                            </tr>
                            <tr  v-for="( input, index ) in contact_nos">
                              <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="30%">Phone {{index+1}}</td>
                              <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="5%">:</td>
                              <td class="text-xs-left text-md-left text-sm-left" width="60%" style="font-size:13px;">{{ input.mobile_number }} <span v-if="input.id == customer.primary_phone_id && contact_nos.length != 1">(Primary)</span></td>
                            </tr>
                            <tr>
                              <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="30%">Pan</td>
                              <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="5%">:</td>
                              <td class="text-xs-left text-md-left text-sm-left" width="60%" style="font-size:13px;">{{ customer.pan }}</td>
                            </tr>
                            
                          </table>
                        </v-flex>
                      </v-container>
                  </v-card>
                    </v-flex>
               
                    <v-flex xs12 sm12 md4>
                      <v-card class="mx-auto" height="100%">
                        <v-card-title>
                          <v-icon outline large left>home</v-icon>
                          <span style="font-size:21px;color:#424242;">Permanent Address</span>
                        </v-card-title>
                        <v-divider class="ml-4 mr-4"></v-divider>
                        <v-container class="text-xs-center text-md-center text-sm-center">
                          <v-flex class="text-xs-center text-md-center text-sm-center"  xs12 sm12 md12>
                            
                            <table class="mytable mytable-head" cellpadding="5">
                              <tr>
                                <td  class="text-xs-left text-md-left text-sm-left grey--text " style="font-size:13px;color:#616161;" width="25%">Address</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;"  width="5%">:</td>
                                <td class="text-xs-left text-md-left text-sm-left " style="font-size:13px;" width="70%">{{address.hfb_no}}</td>
                              </tr>
                               <tr>
                                <td  class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;"  width="25%"></td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;"  width="5%"></td>
                                <td class="text-xs-left text-md-left text-sm-left " width="70%" style="font-size:13px;">{{address.hfb_name}}</td>
                              </tr>
                               <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="25%"></td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="5%"></td>
                                <td class="text-xs-left text-md-left text-sm-left " width="70%" style="font-size:13px;" >{{ address.rlavp }}</td>
                              </tr>
                              <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="30%" style="font-size:13px;color:#616161;">PO</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="5%" style="font-size:13px;color:#616161;">:</td>
                                <td class="text-xs-left text-md-left text-sm-left " width="60%" style="font-size:13px;">{{address.post_office}}</td>
                              </tr>
                                <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="25%" style="font-size:13px;color:#616161;">District</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="5%" style="font-size:13px;color:#616161;">:</td>
                                <td class="text-xs-left text-md-left text-sm-left " width="70%" style="font-size:13px;">{{ address.district_name }}</td>
                              </tr>
                              <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="25%" style="font-size:13px;color:#616161;">State</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="5%" style="font-size:13px;color:#616161;">:</td>
                                <td class="text-xs-left text-md-left text-sm-left " width="70%" style="font-size:13px;">{{address.state_name}}</td>
                              </tr>
                               <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="20%" style="font-size:13px;color:#616161;">PIN</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="5%" style="font-size:13px;color:#616161;">:</td>
                                <td class="text-xs-left text-md-left text-sm-left " width="60%" style="font-size:13px;">{{address.pin}}</td>
                              </tr>
                              <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="20%" style="font-size:13px;color:#616161;">Landmark</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="5%" style="font-size:13px;color:#616161;">:</td>
                                <td class="text-xs-left text-md-left text-sm-left " width="60%" style="font-size:13px;">{{address.landmark}}</td>
                              </tr>
                            </table>
                          </v-flex>
                        </v-container>
                      </v-card>
                    </v-flex>
                    
                    <v-flex xs12 sm12 md4 >
                      <v-card class="mx-auto" height="100%">
                        <v-card-title>
                          <v-icon outline large left>home</v-icon>
                          <span style="font-size:21px;color:#424242;">Present Address</span>
                        </v-card-title>
                        <v-divider class="ml-4 mr-4"></v-divider>
                        <v-container class="text-xs-center text-md-center text-sm-center">
                          <v-flex class="text-xs-center text-md-center text-sm-center"  xs12 sm12 md12>
                            <table class="mytable mytable-head" cellpadding="5">
                              <tr>
                                <td  class="text-xs-left text-md-left text-sm-left grey--text " style="font-size:13px;color:#616161;" width="25%">Address</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;"  width="5%">:</td>
                                <td v-if="customer.same_address=='1'" class="text-xs-left text-md-left text-sm-left " style="font-size:13px;" width="70%">{{address.hfb_no}}</td>
                                <td v-else="customer.same_address=='1'"class="text-xs-left text-md-left text-sm-left " style="font-size:13px;" width="70%">{{other_address.hfb_no}}</td>
                              </tr>
                               <tr>
                                <td  class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;"  width="25%"></td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;"  width="5%"></td>
                                <td v-if="customer.same_address=='1'" class="text-xs-left text-md-left text-sm-left " width="70%" style="font-size:13px;">{{address.hfb_name}}</td>
                                <td v-else="customer.same_address=='1'"class="text-xs-left text-md-left text-sm-left " style="font-size:13px;" width="70%">{{other_address.hfb_name}}</td>
                              </tr>
                               <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="25%"></td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " style="font-size:13px;color:#616161;" width="5%"></td>
                                <td v-if="customer.same_address=='1'" class="text-xs-left text-md-left text-sm-left " width="70%" style="font-size:13px;" >{{ address.rlavp }}</td>
                                <td v-else="customer.same_address=='1'"class="text-xs-left text-md-left text-sm-left " style="font-size:13px;" width="70%">{{other_address.rlavp}}</td>
                              </tr>
                              <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="30%" style="font-size:13px;color:#616161;">PO</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="5%" style="font-size:13px;color:#616161;">:</td>
                                <td v-if="customer.same_address=='1'" class="text-xs-left text-md-left text-sm-left " width="60%" style="font-size:13px;">{{address.post_office}}</td>
                                <td v-else="customer.same_address=='1'"class="text-xs-left text-md-left text-sm-left " style="font-size:13px;" width="70%">{{other_address.post_office}}</td>
                              </tr>
                                <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="25%" style="font-size:13px;color:#616161;">District</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="5%" style="font-size:13px;color:#616161;">:</td>
                                <td v-if="customer.same_address=='1'" class="text-xs-left text-md-left text-sm-left " width="70%" style="font-size:13px;">{{ address.district_name }}</td>
                                <td v-else="customer.same_address=='1'"class="text-xs-left text-md-left text-sm-left " style="font-size:13px;" width="70%">{{other_address.district_name}}</td>
                              </tr>
                              <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="25%" style="font-size:13px;color:#616161;">State</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="5%" style="font-size:13px;color:#616161;">:</td>
                                <td v-if="customer.same_address=='1'" class="text-xs-left text-md-left text-sm-left " width="70%" style="font-size:13px;">{{address.state_name}}</td>
                                <td v-else="customer.same_address=='1'"class="text-xs-left text-md-left text-sm-left " style="font-size:13px;" width="70%">{{other_address.state_name}}</td>
                              </tr>
                               <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="20%" style="font-size:13px;color:#616161;">PIN</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="5%" style="font-size:13px;color:#616161;">:</td>
                                <td v-if="customer.same_address=='1'" class="text-xs-left text-md-left text-sm-left " width="60%" style="font-size:13px;">{{address.pin}}</td>
                                <td v-else="customer.same_address=='1'"class="text-xs-left text-md-left text-sm-left " style="font-size:13px;" width="70%">{{other_address.pin}}</td>
                              </tr>
                              <tr>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="20%" style="font-size:13px;color:#616161;">Landmark</td>
                                <td class="text-xs-left text-md-left text-sm-left  grey--text " width="5%" style="font-size:13px;color:#616161;">:</td>
                                <td v-if="customer.same_address=='1'" class="text-xs-left text-md-left text-sm-left " width="60%" style="font-size:13px;">{{address.landmark}}</td>
                                <td v-else="customer.same_address=='1'"class="text-xs-left text-md-left text-sm-left " style="font-size:13px;" width="70%">{{other_address.landmark}}</td>
                              </tr>
                            </table>
                          </v-flex>
                        </v-container>
                      </v-card>
                    </v-flex>
                   
                  </v-layout>
                </v-container>
              </v-flex>
              
            </v-layout>
          </v-container>
        </v-form>
        
      </template>
    </div>

</template>

<script>

  import axios from 'axios'

  import NoData from '@/components/NoData'
  
  import PageHeader from '@/components/PageHeader'

  import global from '@/components/rbconstants';

 import pSpinner from '@/components/pSpinner';


  export default {

    components : {

        NoData : NoData,
        
        PageHeader : PageHeader,
        
        pSpinner : pSpinner,
    },  
    
   
    mounted() {
      
        this.getDataFromApi()
        
        .then(data => {
          
          this.customer = data.customer_details.customer;
          
          this.contact_nos = data.customer_details.contact_nos;
          
          this.address = data.customer_details.address;
          
          this.other_details = data.customer_details.other_details;
          
          this.other_address = data.customer_details.other_address;
          
          this.rb_base_url = data.customer_details.rupbee_photo_url
          
          // if(this.rb_base_url != '') {
            
            this.image_url = this.encode+data.customer_details.image;
           
            // this.showImage(this.rb_base_url, this.customer.id)
            
          // } else {
            
            
          //   this.image_url = 'https://cdn4.vectorstock.com/i/1000x1000/35/53/person-icon-female-user-profile-avatar-vector-18833553.jpg' 
           
          //   // this.rb_base_url = 'https://cdn4.vectorstock.com/i/1000x1000/35/53/person-icon-female-user-profile-avatar-vector-18833553.jpg'
            
          // }
       
          
          this.loading = false;
          
        })
    },
    
   
      
    data: () => ({
      
        address : [],
        
        customer : [],
        
        contact_nos : [],
        
        other_details : [],
        
        other_address : [],
        
        image_url: '',
        
        rb_base_url : '',
        
        page_title : "My Profile",
        
        loading : false,
        
        encode : 'data:image/png;base64,'
    }),
    
	methods : {
	    
        getDataFromApi() {
            
          this.loading = true;
          
          this.table_loading = true
          
          return new Promise((resolve, reject) => {
          
            var app = this;
            
            var form_post_data = {};
            
            var link = global.links.my_profile;
            
            axios.post(link, {
            
              params : form_post_data,
            
            }, { headers : global.header }) 
            
            .then(function (response) {
              
              if(response.status == 200) {
                
                var customer_details = response.data.data;
                
                setTimeout(() => {
                  
                  app.table_loading = false
                  
                  resolve({
                    
                    customer_details
                  
                  })
                  
                }, 1000)
              
              }
            
            }) .catch(function (error) {
             
              app.loading = false;
            
            });
          
          });
          
        },
        
        // showImage(base_url, customer_id) {
          
        //   var app = this 
          
        //   if(base_url != '') {
            
        //     var link = global.links.profile_photo
      
        //     link = link.replace(':id', customer_id)
            
        //     app.image_url = link 
          
        //   } else {
            
        //     app.image_url = 'https://cdn4.vectorstock.com/i/1000x1000/35/53/person-icon-female-user-profile-avatar-vector-18833553.jpg' 
        //     // app.rb_base_url = 'https://cdn4.vectorstock.com/i/1000x1000/35/53/person-icon-female-user-profile-avatar-vector-18833553.jpg'
            
        //   }
          
        
        // }
          
	    },
	
  }
  
</script>

<style scoped>

  .Row
{
    display: table;
    width: 100%; 
    table-layout: fixed; 
    border-spacing: 10px;
}
.Column
{
    display: table-cell;
    /*background-color: #FBDAD3; */
}
  
.mytable {
      border-collapse: collapse;
      width: 100%;
      background-color: white;
    }
    .mytable-head {
      /*border: 1px solid black;*/
      margin-bottom: 0;
      padding-bottom: 0;
    }
    /*.mytable-head td {*/
    /*  border: 1px solid black;*/
    /*}*/
    /*.mytable-body {*/
    /*  border: 1px solid black;*/
    /*  border-top: 0;*/
    /*  margin-top: 0;*/
    /*  padding-top: 0;*/
    /*  margin-bottom: 0;*/
    /*  padding-bottom: 0;*/
    /*}*/
    /*.mytable-body td {*/
    /*  border: 1px solid black;*/
    /*  border-top: 0;*/
    /*}*/
    /*.mytable-footer {*/
    /*  border: 1px solid black;*/
    /*  border-top: 0;*/
    /*  margin-top: 0;*/
    /*  padding-top: 0;*/
    /*}*/
    /*.mytable-footer td {*/
    /*  border: 1px solid black;*/
    /*  border-top: 0;*/
    /*}*/
    
    th, td {
  padding: 10px;
}
</style>